import PeriodChangeColumn from "../../reports/reports/columns/PeriodChangeColumn.js";

/**
 * Represent a column for a forecast. The subclasses represent different
 * kinds of columns.
 *
 * @abstract
 * @param {MonthPeriod} start - The forecast period to which the
 *   column is associated
 */
export default class AbstractForecastColumn extends PeriodChangeColumn {
	constructor({ start }) {
		super(...arguments);

		this._start = start;
	}

	accept(visitor) {
		return visitor.visitAbstractForecastColumn(this);
	}

	getStart() {
		return this._start;
	}

	getFiscalYear() {
		return this._start?.getFiscalYear();
	}

	isClosing() {
		return this._start?.isClosing();
	}

	isFrozenPeriodForecastColumn() {
		return false;
	}
}
